module.exports = __webpack_public_path__ + "img/zilan.ec5c2d00.png";